import React from 'react'
import AiHero from '../../Components/Automation/AiHero'
import WhyAIAutomation from '../../Components/Automation/WhyAIAutomation'
import TechServicesSection from '../../Components/Automation/TechServicesSection'
import IndustriesWeServe from '../../Components/Automation/IndustriesWeServe'
import WhyPartnerWithUs from '../../Components/Automation/WhyPartnerWithUs'
import { ArrowRight, CheckCircle, Circle } from 'lucide-react'
import Banner from '../../Components/Banner'
import { Helmet } from 'react-helmet-async';

const featuresData = [
    {
        id: 1,
        title: "MES Consulting & Strategy",
        description:
            "We help evaluate your current setup, understand MES maturity, and build a clear, practical roadmap along with a strong business case to support smooth MES adoption or improvement.",
        image: "/assets/v/item12.png",
    },
    {
        id: 2,
        title: "MES Implementation & Integration",
        description:
            "We deliver end-to-end MES platform deployment with smooth, reliable integration into ERP systems, SCADA, PLCs, and IoT devices helping all your operations work together seamlessly and efficiently.",
        image: "/assets/v/item3.png",
    },
    {
        id: 3,
        title: "Custom MES Development",
        description:
            "We build tailored applications that fit your workflows, meet compliance needs, and solve industry-specific challenges with ease.",
        image: "/assets/v/item4.png",
    },
    {
        id: 4,
        title: "Upgrades & Modernization",
        description:
            "We help you move from legacy MES systems to modern, cloud-based and mobile-ready platforms that are easier to use, more flexible, and built for today’s fast-changing business needs.",
        image: "/assets/v/item9.png",
    },
    {
        id: 5,
        title: "Support & Managed Services",
        description:
            "We ensure 24/7 monitoring, quick issue handling, support, and continuous system improvements always running smoothly.",
        image: "/assets/v/item1.png",
    },
    {
        id: 6,
        title: "Analytics & Reporting",
        description:
            "Real-time dashboards that simplify tracking OEE, downtime, quality, and throughput for better decisions.",
        image: "/assets/v/item6.png",
    },
];
// --- DATA ---
const services = [
    {
        id: 1,
        title: "Cloud Services",
        category: "service",
        desc: "Elevate your applications with Mobikode’s cloud services designed for performance optimization, data protection and simplicity in migrations. We also cut costs so you can do more of what really matters!",
        defaultBg: "bg-gradient-to-b from-[#01386A] to-[#1C355E]", // Deep Blue Gradient
    },
    {
        id: 2,
        title: "Cloud Migration",
        category: "service",
        desc: "The future is now. Cloud is essential for organizations today to be more efficient and profitable. Mobikode can help you migrate your data into this new way of thinking by strengthening the core operations strategy and build a future-ready organization.",
        defaultBg: "bg-gradient-to-r from-[#01386A] to-[#4B6CB7]", // Blue to Royal Blue (Replaced Orange)
    },
    {
        id: 3,
        title: "DevOps Services",
        category: "service",
        desc: "We implement a continuous and data-driven approach to help you realize better outcomes with your infrastructure through the latest tech trends, tools, techniques – and even old-fashioned hard work!",
        defaultBg: "bg-gradient-to-br from-[#01386A] to-[#8E9EAB]", // Blue to Grayish Blue
    },
    {
        id: 4,
        title: "Cloud Services",
        category: "service",
        desc: "Elevate your applications with Mobikode’s cloud services designed for performance optimization, data protection and simplicity in migrations. We also cut costs so you can do more of what really matters!",
        defaultBg: "bg-gradient-to-b from-[#01386A] to-[#1C355E]", // Deep Blue Gradient
    },
    {
        id: 5,
        title: "Cloud Migration",
        category: "service",
        desc: "The future is now. Cloud is essential for organizations today to be more efficient and profitable. Mobikode can help you migrate your data into this new way of thinking by strengthening the core operations strategy and build a future-ready organization.",
        defaultBg: "bg-gradient-to-r from-[#01386A] to-[#4B6CB7]", // Blue to Royal Blue (Replaced Orange)
    },
    {
        id: 6,
        title: "DevOps Services",
        category: "service",
        desc: "We implement a continuous and data-driven approach to help you realize better outcomes with your infrastructure through the latest tech trends, tools, techniques – and even old-fashioned hard work!",
        defaultBg: "bg-gradient-to-br from-[#01386A] to-[#8E9EAB]", // Blue to Grayish Blue
    },
];

const toolsData = [
    {
        id: 1,
        title: "Cloud",
        desc: "AWS, Azure, Google Cloud",
    },
    {
        id: 2,
        title: "Data Platforms",
        desc: "Snowflake, BigQuery, Redshift, Synapse",
    },
    {
        id: 3,
        title: "BI & Visualization",
        desc: "Power BI, Tableau, Looker",
    },
    {
        id: 4,
        title: "AI & ML",
        desc: "Python, TensorFlow, PyTorch",
    },
    {
        id: 5,
        title: "Integration",
        desc: "Kafka, Airflow, dbt",
    },
];

const outcomesData = [
    {
        id: 1,
        text: "Faster, data-driven decision-making",
    },
    {
        id: 2,
        text: "Single source of truth across the enterprise",
    },
    {
        id: 3,
        text: "Predictive insights & automation",
    },
    {
        id: 4,
        text: "Improved efficiency, cost control & revenue growth",
    },
];

const whyMobikodePoints = [
    "Seamless integration with ERP, SCADA, and IoT systems for unified operations",
    "Ready-to-use accelerators and frameworks to speed up delivery and results",
    "A proven global delivery model ensuring reliability, consistency, and scalability across projects",
];

const whyMobikodePoints1 = [
    "Siemens Opcenter (Camstar)",
    "Rockwell FactoryTalk",
    "GE Proficy",
    "AVEVA / Wonderware MES",
    "SAP Digital Manufacturing Cloud (DMC)",
    "Custom & Hybrid MES Solutions",
];
const whyMobikodePoints2 = [
    "Automotive",
    "Electronics & High Tech",
    "Pharmaceuticals & Life Sciences",
    "Food & Beverage",
    "Industrial Equipment",
    "Chemicals",
];


function ManufacturingExecutionSystem() {
    return (
        <div>
            <Helmet>
    <title>
        Manufacturing Execution System (MES) Solutions & Services | Mobikode
    </title>

    <meta
        name="description"
        content="Mobikode delivers Manufacturing Execution System (MES) solutions for smarter production, real-time visibility, seamless integration, process optimization, analytics, modernization, and reliable manufacturing operations."
    />

    <meta
        name="keywords"
        content="Manufacturing Execution System, MES Solutions, MES Services, MES Consulting Services, MES Consulting and Strategy, MES Implementation, MES Integration, MES Software Development, Custom MES Development, MES Modernization, MES Upgrade Services, MES Managed Services, MES Support Services, MES Analytics and Reporting, Manufacturing Software Solutions, MES ERP Integration, MES SCADA Integration, MES IoT Integration, Manufacturing Digital Transformation"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/manufacturing-execution-system"
    />

    <meta
        property="og:title"
        content="Manufacturing Execution System (MES) Solutions & Services | Mobikode"
    />

    <meta
        property="og:description"
        content="Improve manufacturing operations with Mobikode's MES solutions covering consulting, implementation, integration, custom development, modernization, analytics, and managed support."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/manufacturing-execution-system"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/service-detail/img12.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Manufacturing Execution System (MES) Solutions & Services | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Explore Mobikode's MES expertise for consulting, implementation, ERP and shop-floor integration, custom development, modernization, analytics, and managed services."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/service-detail/img12.png"
    />
</Helmet>
            <AiHero title="Manufacturing Execution System (MES)" imgData="/assets/service-detail/img12.png" />
            <section className="w-full pt-16 lg:pt-[100px] bg-white overflow-hidden relative">
                <div className="max-w-[1440px] mx-auto px-[15px] lg:px-[80px]">
                    <div className="relative w-full flex flex-col lg:flex-row lg:items-center group lg:h-[507px]">
                        <div className="relative lg:absolute top-0 right-0 w-full lg:max-w-[656px] h-[250px] md:h-[350px] lg:h-full bg-gray-100 overflow-hidden">
                            <img
                                src="/assets/v/item11.png"
                                alt="ai automation"
                                className="w-full h-full object-cover mix-blend-multiply transition-transform duration-700 group-hover:scale-105"
                            />
                        </div>
                        <div className="relative z-20 w-[92%] sm:w-[85%] lg:w-full max-w-[719px] mx-auto lg:mx-0 bg-white shadow-[0_10px_40px_rgba(0,0,0,0.1)] px-[20px] py-[30px] lg:px-[60px] lg:py-[80px] -mt-[40px] lg:mt-0">
                            <p className="text-[#49577A] w-full text-[14px] lg:text-[16px] leading-[1.6] font-graphik font-[500] text-justify">
                                At Mobikode, we help manufacturers simplify and improve their day-to-day operations with practical MES solutions. By connecting planning with what’s actually happening on the shop floor, we bring better visibility, smoother workflows, and consistent quality. Whether you’re starting fresh or upgrading, we build solutions that fit your needs and grow with you.
                            </p>
                            <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A]"></div>
                            <div className="absolute bottom-0 left-0 h-[4px] bg-[#ED6800] w-0 transition-all duration-500 ease-out group-hover:w-full"></div>
                        </div>
                    </div>
                </div>
            </section>
            <WhyAIAutomation title="Our MES Service Portfolio" fData={featuresData} />

            <section className="w-full bg-[#FDFDFD] pb-16 lg:pb-24 relative overflow-hidden">
                <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px] relative z-10">

                    <div className="bg-white shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-200 flex flex-col lg:flex-row overflow-hidden">

                        <div className="flex-1 p-8 lg:p-12 relative border-b lg:border-b-0 lg:border-r border-gray-200">
                            <h2 className="text-[#01386A] font-sora text-[20px] lg:text-[30px] font-[600] mb-8">
                                MES Platforms We Support
                            </h2>

                            <div className="flex flex-col gap-2">
                                {whyMobikodePoints1.map((point, index) => (
                                    <div
                                        key={index}
                                        className="flex items-center gap-4 group p-3 rounded-lg hover:bg-[#F9F9F9] hover:translate-x-1 transition-all duration-300"
                                    >
                                        <div className="w-8 h-8 rounded-full bg-[#01386A]/5 flex items-center justify-center group-hover:bg-[#F06115]/10 transition-colors duration-300 shrink-0">
                                            <Circle size={10} className="text-[#01386A] group-hover:text-[#F06115] transition-colors duration-300" />
                                        </div>
                                        <p className="text-[#49577A] font-graphik lg:text-[16px] text-[14px] font-[500] group-hover:text-[#01386A] transition-colors duration-300">
                                            {point}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="flex-1 p-8 lg:p-12 relative">
                            <h2 className="text-[#01386A] font-sora text-[20px] lg:text-[30px] font-[600] mb-8">
                                Industries We Serve
                            </h2>

                            <div className="flex flex-col gap-2">
                                {whyMobikodePoints2.map((point, index) => (
                                    <div
                                        key={index}
                                        className="flex items-center gap-4 group p-3 rounded-lg hover:bg-[#F9F9F9] hover:translate-x-1 transition-all duration-300"
                                    >
                                        <div className="w-8 h-8 rounded-full bg-[#01386A]/5 flex items-center justify-center group-hover:bg-[#F06115]/10 transition-colors duration-300 shrink-0">
                                            <Circle size={10} className="text-[#01386A] group-hover:text-[#F06115] transition-colors duration-300" />
                                        </div>
                                        <p className="text-[#49577A] font-graphik lg:text-[16px] text-[14px] font-[500] group-hover:text-[#01386A] transition-colors duration-300">
                                            {point}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>

                    </div>

                </div>
            </section>
            <section className="w-full bg-white relative overflow-hidden">
                <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px] relative z-10">
                    <div className="bg-[#F9F9F9] p-6 lg:p-12 border border-gray-100 flex flex-col lg:flex-row items-stretch gap-10 lg:gap-16">
                        <div className="w-full lg:w-1/2 flex flex-col justify-center">
                            <div className="text-left mb-8">
                                <h2 className="text-[#01386A] font-sora text-[20px] lg:text-[30px] font-[600] mb-4">
                                    Why Choose Mobikode?
                                </h2>
                                <div className="w-20 h-1 bg-[#F06115]"></div>
                            </div>

                            <div className="grid grid-cols-1 gap-y-5 gap-x-12 pb-[24px]">
                                {whyMobikodePoints.map((point, index) => (
                                    <div key={index} className="flex items-start gap-3 group">
                                        <div className="mt-1 flex-shrink-0">
                                            <CheckCircle size={20} className="text-[#F06115] fill-[#F06115]/10" />
                                        </div>
                                        <p className="text-[#01386A] font-graphik text-[14px] lg:text-[16px] font-[500] group-hover:text-[#F06115] transition-colors duration-300">
                                            {point}
                                        </p>
                                    </div>
                                ))}
                            </div>

                            <p className="text-[#49577A] font-graphik font-[500] text-[14px] lg:text-[16px]">
                                From the shop floor to the boardroom, we help manufacturers make sense of their data, maintain quality standards, and run operations with greater speed and flexibility.
                            </p>
                        </div>

                        <div className="w-full lg:w-1/2 flex">
                            <div className="relative w-full h-full min-h-[350px]">
                                <img
                                    src="/assets/what/img5.png"
                                    alt="Why Choose Mobikode"
                                    className="w-full h-full object-cover shadow-lg"
                                />
                                <div className="absolute -bottom-4 -left-4 w-24 h-24 bg-[#F06115]/10 -z-10"></div>
                                <div className="absolute -top-4 -right-4 w-12 h-12 bg-[#01386A]/5 -z-10"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <section className="relative w-full h-[400px] lg:h-[507px] flex items-center justify-center overflow-hidden">
                <div className="absolute inset-0 z-0">
                    <img
                        src="/assets/career/img12.png"
                        alt="Manufacturing Execution System Background"
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-black/10"></div>
                </div>
                <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] lg:px-[80px] h-full flex items-center lg:items-center ">
                    <div className="bg-white p-8 lg:p-12 max-w-[588px] shadow-2xl rounded-sm">

                        <h2 className="text-[#01386A] text-[30px] lg:text-[40px] font-[600] font-sora leading-tight mb-6">
                            Manufacturing Execution Systems (MES)
                        </h2>
                        <p className="text-[#49577A] text-[16px] leading-[24px] font-graphik mb-8">

                            Get real-time visibility of your production floor with our MES solutions, helping you connect planning and execution for smoother, more efficient operations.
                        </p>
                        <a href="/contact" className="inline-flex items-center gap-2 text-[#01386A] underline font-graphik font-semibold text-lg hover:gap-3 transition-all duration-300 group">
                            Contact Now
                            <ArrowRight size={20} className="transition-transform group-hover:translate-x-1" />
                        </a>

                    </div>

                </div>

            </section> */}
            <Banner title="Manufacturing Execution System (MES)" text=" Empowering businesses with intelligent, autonomous AI solutions that drive efficiency and innovation." />
        </div>
    )
}

export default ManufacturingExecutionSystem
